import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-5 py-16 md:py-24" aria-labelledby="faq-title" data-id="element-124" data-mp="1ceqefpoyz1ic">
      <div className="mx-auto max-w-3xl" data-id="element-125" data-mp="2a28kgsr8xpin">
        <p className="text-center text-sm font-bold uppercase tracking-[0.14em] text-brandDark" data-id="element-126" data-mp="2a17a6qi2171z">Frequently Asked Questions</p>
        <h2 id="faq-title" className="mt-3 text-center font-display text-3xl font-black leading-tight text-ink md:text-5xl" data-id="element-127" data-mp="253xa8gx1hczw">
          Your Questions, Answered
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-128" data-mp="1v3y56tztw4rs">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="rounded-2xl bg-white" data-id="element-129" data-mp="omt2lylis9h8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 rounded-2xl px-5 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-130" data-mp="jp1b35osepdk">
                  <span className="font-display text-[17px] font-bold leading-snug text-ink" data-id="element-131" data-mp="1fodlc3ch0sll">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brandDark transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-132" data-mp="11xijhb0e3bri" />
                </button>
                <AnimatePresence initial={false} data-id="element-133" data-mp="s0mal46kwnmf">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-134" data-mp="wyxih9dbco20">
                      <p className="px-5 pb-5 leading-relaxed text-slate-600" data-id="element-135" data-mp="2kw6oo4pdbwa3">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCTA label="I’m Ready — Give Me TRT Blueprint" data-id="element-136" data-mp="2aysakbqx3jky" />
      </div>
    </section>;
}